import { useQuery } from "react-query";
import ClientScreen from "..";
import Context from "../../../context";
import api from "../../../api";
import values from "../../../values";
import { useState } from "react";
import { TModal } from "../../../types/common.type";
import utils from "../../../utils";
import {
  ICreateAndUpdateOrder,
  IRequestOrder,
} from "../../../types/order.interface";
import {
  ICreateAndUpdateClient,
  IRequestClient,
} from "../../../types/client.interface";

const CompanyContainer = () => {
  const [showModal, setShowModal] = useState<TModal>();
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedClient, setSelectedClient] =
    useState<ICreateAndUpdateClient>();
  const [requestClient, setRequestClient] = useState<IRequestClient>({
    page: 1,
    limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
  });

  const resultClient = useQuery(
    [values.useQueryKeys.getAllClient, requestClient],
    () =>
      api.getMethod.common.findClient({
        ...requestClient,
      })
  );

  const updateClient = async (ClientInfo: ICreateAndUpdateClient) => {
    setLoading(true);
    const result = await api.putMethod.common.updateClient(ClientInfo);
    if (result) {
      resultClient.refetch();
      setLoading(false);
      setShowModal("NONE");
      utils?.successHandler(result?.CODE);
      return true;
    } else {
      utils?.errorHandler(result?.CODE);
      return false;
    }
  };
  const removeClient = async (clientId: string) => {
    setLoading(true);
    const result = await api.deleteMethod.common.deleteClient(clientId);
    if (result) {
      resultClient.refetch();
      setLoading(false);
      setShowModal("NONE");
      utils?.successHandler(result?.CODE);
      return true;
    } else {
      utils?.errorHandler(result?.CODE);
      return false;
    }
  };
  // const createClient = async (ClientInfo: ICreateAndUpdateClient) => {
  //   setLoading(true);
  //   const result = await api.postMethod.common.createClient(ClientInfo);
  //   if (result) {
  //     resultClient.refetch();
  //     setLoading(false);
  //     setShowModal("NONE");
  //     utils?.successHandler(result?.CODE);
  //     return true;
  //   } else {
  //     utils?.errorHandler(result?.CODE);
  //     setLoading(false);
  //     return false;
  //   }
  // };

  return (
    <Context.ClientScreen.Provider
      value={{
        resultClient,
        requestClient,
        setRequestClient,
        showModal,
        setShowModal,
        selectedClient,
        setSelectedClient,
        loading,
        setLoading,
        updateClient,
        removeClient,
      }}
    >
      <ClientScreen />
    </Context.ClientScreen.Provider>
  );
};

export default CompanyContainer;
